import { render, staticRenderFns } from "./EditFacility.vue?vue&type=template&id=4d15c61f"
import script from "./EditFacility.vue?vue&type=script&lang=js"
export * from "./EditFacility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports